import React from 'react'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'

import { Body, Header, LinkContainer, StyledLink, Text } from './styles'

export const UnsupportedBanner: React.FC = () => {
  const {
    magnolia: { unsupportedBanner: strings },
  } = useTranslation()

  const browsers = [
    { name: 'Chrome', url: 'https://www.google.com/chrome/' },
    { name: 'Firefox', url: 'https://www.mozilla.org/en-US/firefox/' },
    { name: 'Opera', url: 'https://www.opera.com/' },
    { name: 'Safari', url: 'https://www.apple.com/safari/' },
  ]

  return (
    <Body>
      <Header>{strings.headline}</Header>
      <Text>{strings.text}</Text>
      <LinkContainer>
        {browsers.map(browser => (
          <StyledLink key={browser.name} href={browser.url}>
            {browser.name}
          </StyledLink>
        ))}
      </LinkContainer>
    </Body>
  )
}
